import axios from 'axios';
import { AdminUsersType } from '../components/organisms/Maintenance/Table/MaintenanceAdminUsersTable';
import { CategoryType } from '../components/organisms/Maintenance/Table/MaintenanceCategoryTable';
import { MailingListType } from '../components/organisms/Maintenance/Table/MaintenanceMailingListTable';
import { PhrasesType } from '../components/organisms/Maintenance/Table/MaintenancePhrasesTable';
import { SettingsType } from '../components/organisms/Maintenance/Table/MaintenanceSettingsTable';
import { SignagesType } from '../components/organisms/Maintenance/Table/MaintenanceSignageTable';
import { TrainGroupsType } from '../components/organisms/Maintenance/Table/MaintenanceTrainGroupsTable';
import { MainteTrainsType } from '../components/organisms/Maintenance/Table/MaintenanceTrainsTable';
import { MessageType } from '../components/organisms/Message/MessageBody';
import { NoticeMessageType } from '../pages/NoticeMessageList';

export interface CategroyNameType {
  id: number;
  category: string;
}

export interface TrainGroupsNameType {
  id: number;
  type: string;
}

export interface AdminUsersResponseType {
  success: boolean;
  data: AdminUsersType[] | null;
  message: unknown | null;
}
export interface TrainsResponseType {
  success: boolean;
  data: MainteTrainsType[] | TrainGroupsNameType[] | null;
  message: unknown | null;
}

export interface TrainGroupsResponseType {
  success: boolean;
  data: TrainGroupsType[] | null;
  message: unknown | null;
}
export interface CategoryResponseType {
  success: boolean;
  data: CategoryType[] | null;
  message: unknown | null;
}
export interface PhrasesResponseType {
  success: boolean;
  data: PhrasesType[] | CategroyNameType[] | null;
  message: unknown | null;
}
export interface MailingListResponseType {
  success: boolean;
  data: MailingListType[] | null;
  message: unknown | null;
}
export interface SignagesResponseType {
  success: boolean;
  data: SignagesType[] | null;
  message: unknown | null;
}
export interface SettingsResponseType {
  success: boolean;
  data: SettingsType[] | null;
  message: unknown | null;
}

export interface MessageResponsType {
  success: boolean;
  data: MessageType | null;
  message: unknown | null;
}

export interface NoticeMessageListResponsType {
  success: boolean;
  data: NoticeMessageType[] | null;
  message: unknown | null;
}

/*`${process.env.REACT_APP_PROTOCOL}://${'naga-den.megakiku.net'}:${
        process.env.REACT_APP_PORT_API
      }/api`*/

const SERVER_URL =
  process.env.NODE_ENV === 'development'
    ? process.env.REACT_APP_API_BASE_URL
    : `${process.env.REACT_APP_PROTOCOL}://${window.location.hostname}:${process.env.REACT_APP_PORT_API}/api`;

export const ApiClient = axios.create({
  baseURL: SERVER_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

export const ApiErrorMessage = (e: unknown) => {
  if (axios.isAxiosError(e)) {
    return e.response;
  }
  return null;
};
